<template>
  <v-card outlined class="card-group" :height="400">
    <v-card-title class="card-title-group">
      <v-tabs
        v-model="tab"
        class="tab-card-control"
        fixed-tabs
        centered
        hide-slider
        :height="15"
      >
        <v-tab v-for="item in tabCardGroupSatellites" :key="item">{{
          item
        }}</v-tab>
      </v-tabs>
    </v-card-title>
    <v-card-text class="card-content-group">
      <v-tabs-items v-model="tab">
        <v-tab-item v-for="item in tabCardGroupSatellites" :key="item">
          <v-container v-if="item === 'Groups'" class="container-card-group">
            <ScreeningCatalogueAnalysisGroupCard
              v-on:satellite-norad-id-method="updateSatelliteInformation"
            />
          </v-container>
          <v-container v-if="item === 'Satellite'" class="container-card-group">
            <v-container
              v-if="infoSatellite != null"
              class="container-card-group"
            >
              <ScreeningCatalogueAnalysisSatelliteInfoCard
                :infoSatellite="infoSatellite" /></v-container
            ><v-container v-else class="justify-center">
              <span>
                You need to click on a satellite norad ID from a group to see
                informations about this one</span
              >
            </v-container>
          </v-container>
        </v-tab-item>
      </v-tabs-items>
    </v-card-text>
  </v-card>
</template>
<script>
import { mapGetters } from 'vuex'
import ScreeningCatalogueAnalysisSatelliteInfoCard from './ScreeningCatalogueAnalysisSatelliteInfoCard.vue'
import ScreeningCatalogueAnalysisGroupCard from './ScreeningCatalogueAnalysisGroupCard.vue'
import defense from '../../mixins/defense.js'
import spaceObjectGroupUtils from '../../mixins/spaceObjectGroupUtils.js'
export default {
  name: 'ScreeningCatalogueAnalysisGroupAndSatelliteCard',
  props: {},
  components: {
    ScreeningCatalogueAnalysisSatelliteInfoCard,
    ScreeningCatalogueAnalysisGroupCard
  },
  mixins: [defense, spaceObjectGroupUtils],
  data() {
    return {
      tab: null,
      tabCardGroupSatellites: ['Groups', 'Satellite'],
      infoSatellite: null
    }
  },
  watch: {},
  computed: {
    ...mapGetters({
      currentUser: 'currentUser'
    })
  },
  mounted() {},
  methods: {
    async updateSatelliteInformation(item) {
      this.infoSatellite = await this.getDataSatelliteByNoradId(item)
      if (this.infoSatellite.noradId == null) {
        this.infoSatellite = { noradId: item }
      }
      this.tab = 1
    }
  }
}
</script>
<style scoped>
.card-group {
  border: 2px solid;
  border-color: black;
}
.card-content-group {
  height: 350px;
  padding: 0%;
}
.card-title-group {
  justify-content: center;
  align-content: center;
  font-size: small;
  border-bottom: 2px solid;
  border-color: black;
  height: 15px;
}

.current-group-title {
  width: 40%;
  font-size: 12px;
}
.container-card-group {
  margin: 0%;
  padding: 0%;
}
</style>
